import { Component } from '@angular/core';

import { CommonModule } from '@angular/common';
import { DesignAngularKitModule } from 'design-angular-kit';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule, DesignAngularKitModule],
  template: `
    <div
      class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-white bg-opacity-75"
      *ngIf="loaderService.loader$ | async"
      style="z-index: 1050"
    >
      <it-spinner size="lg"></it-spinner>
    </div>
  `,
})
export class AppLoaderComponent {
  constructor(public loaderService: LoaderService) {}
}
